export type SupplierOfferSourceKeyType = 'PO_ADD' | 'PO_DETAILS' | 'MAIN' | 'PR_DETAILS';

export type SupplierOfferSourceValueType = 'po-add' | 'po-details' | 'main' | 'pr-details';

export type SupplierOfferType = 'PURCHASE_REQUEST' | 'PURCHASE_ORDER' | 'NONE';
export type SupplierOfferValueType = 'po' | 'pr' | 'none';

export const SUPPLIER_OFFER_SOURCE: Record<SupplierOfferSourceKeyType, SupplierOfferSourceValueType> = {
  MAIN: 'main',
  PO_ADD: 'po-add',
  PR_DETAILS: 'pr-details',
  PO_DETAILS: 'po-details',
};
export const SUPPLIER_OFFER_TYPE: Record<SupplierOfferType, SupplierOfferValueType> = {
  PURCHASE_ORDER: 'po',
  PURCHASE_REQUEST: 'pr',
  NONE: 'none',
};
